import React from 'react';

interface IconProps {
  width?: number;
  height?: number;
  color?: string;
  onClick?: () => void;
}

const DishIcon: React.FC<IconProps> = ({
  width = 20,
  height = 20,
  color = "rgb(69, 110, 141)",
  onClick = () => {},
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      fill={color}
    >
      <g>
        <path d="M3,22h1.5h23.1H29c0.6,0,1-0.4,1-1s-0.4-1-1-1h-1c-0.2-5.7-4.1-10.4-9.3-11.7C18.9,7.9,19,7.5,19,7c0-1.7-1.3-3-3-3
          s-3,1.3-3,3c0,0.5,0.1,0.9,0.3,1.3C8.1,9.6,4.2,14.3,4,20H3c-0.6,0-1,0.4-1,1S2.4,22,3,22z"/>
        <path d="M5.5,24l0.8,1.5C6.4,25.8,6.8,26,7.2,26h17.7c0.4,0,0.7-0.2,0.9-0.5l0.8-1.5H5.5z"/>
      </g>
    </svg>
  );
};

export default DishIcon;
